import { QuestionType } from "../../utils";
import {
  ADD_NEW_QUESTION_OPTIONS,
  CREATE_RESOURCE_QUESTION_SUCCESS,
  CREATE_RESOURCE_SUCCESS,
  CREATE_SINGLE_RESOURCE_FILE_SUCCESS,
  DELETE_BULK_UPLOAD_FILE,
  DELETE_RESOURCE_FILE_SUCCESS,
  DELETE_RESOURCE_QUESTION_SUCCESS,
  DELETE_RESOURCE_SUCCESS,
  GET_RESOURCE_DROPDOWN_LIST_SUCCESS,
  GET_RESOURCE_FILE_LIST_SUCCESS,
  GET_RESOURCE_LIST_FAILED,
  GET_RESOURCE_LIST_SUCCESS,
  GET_RESOURCE_QUESTIN_LIST_SUCCESS,
  RESET_BULK_UPLOAD_FILE_LIST,
  RESET_NEW_CURRENT_QUESTIONS,
  RESET_RESOURCE_FILE_DETAIL,
  RESET_RESOURCES,
  SEARCH_RESOURCE_FILE_DETAILS_SUCCESS,
  SET_BULK_FILE_LIST,
  SET_BULK_UPLOAD_FILE_PROGRESS,
  SET_NEW_LOCAL_QUESTION,
  UPDATE_NEW_LOCAL_QUESTION,
  UPDATE_NEW_LOCAL_QUESTION_OPTIONS,
  UPDATE_RESOURCE_FILE_SUCCESS,
  UPDATE_RESOURCE_QUESTION_SUCCESS,
  UPDATE_RESOURCE_SUCCESS,
} from "../constants";
import { cloneDeep, remove } from "lodash";

export const initialState = {
  resourceDetails: undefined,
  resourceFileDetails: undefined,
  bulkFileList: [],
  resourceDropdownList: [],
  searchedFileDetails: undefined,
  resourceQuestionList: [],
  newQuestion: undefined,
};
export const ResourceReducer = (state = initialState, action) => {
  //switch between action.type
  switch (action.type) {
    case GET_RESOURCE_LIST_SUCCESS:
      return {
        ...state,
        resourceDetails: action.payload,
      };
    case GET_RESOURCE_LIST_FAILED:
      return {
        ...state,
        resourceDetails: undefined,
      };
    case GET_RESOURCE_DROPDOWN_LIST_SUCCESS:
      return {
        ...state,
        resourceDropdownList: action.payload,
      };
    case CREATE_RESOURCE_SUCCESS: {
      const tempoResDetail = cloneDeep(state.resourceDetails);
      tempoResDetail.push(action.payload);
      return {
        ...state,
        resourceDetails: tempoResDetail,
      };
    }

    case DELETE_RESOURCE_SUCCESS: {
      let tempoResDetail = cloneDeep(state.resourceDetails);
      tempoResDetail = tempoResDetail.filter(
        (item) => !action.payload.ids.includes(item._id)
      );
      return {
        ...state,
        resourceDetails: tempoResDetail,
      };
    }
    case UPDATE_RESOURCE_SUCCESS: {
      let tempoResDetail = cloneDeep(state.resourceDetails);
      for (let i = 0; i < action.payload.length; i++) {
        const index = tempoResDetail.findIndex(
          (obj) => obj._id === action.payload[i]._id
        );
        if (index !== -1) {
          tempoResDetail[index] = action.payload[i];
        }
      }
      return {
        ...state,
        resourceDetails: tempoResDetail,
      };
    }
    case GET_RESOURCE_FILE_LIST_SUCCESS: {
      return {
        ...state,
        resourceFileDetails: action.payload,
      };
    }
    case CREATE_SINGLE_RESOURCE_FILE_SUCCESS: {
      const tempoResFileDetail = cloneDeep(state.resourceFileDetails);

      tempoResFileDetail.data.push(action.payload);
      return {
        ...state,
        resourceFileDetails: tempoResFileDetail,
      };
    }
    case DELETE_RESOURCE_FILE_SUCCESS: {
      const tempResourceFileDetails = cloneDeep(state.resourceFileDetails);
      remove(tempResourceFileDetails.data, (obj) => obj._id === action.payload);
      return {
        ...state,
        resourceFileDetails: tempResourceFileDetails,
      };
    }
    case SET_BULK_FILE_LIST: {
      // let tempBulkFileListDetails = cloneDeep(state.bulkFileList);
      // let newFiles = cloneDeep(action.payload);
      // const ftempBulkFileListDetails = tempBulkFileListDetails.concat(newFiles);
      return {
        ...state,
        bulkFileList: action.payload,
      };
    }
    case DELETE_BULK_UPLOAD_FILE: {
      let tempBulkFileListDetails = cloneDeep(state.bulkFileList);
      remove(tempBulkFileListDetails, (obj) => obj.id === action.payload);
      return {
        ...state,
        bulkFileList: tempBulkFileListDetails,
      };
    }

    case SET_BULK_UPLOAD_FILE_PROGRESS: {
      let tempBulkFileListDetails = cloneDeep(state.bulkFileList);
      if (tempBulkFileListDetails.length > action?.payload?.index) {
        tempBulkFileListDetails[action?.payload?.index].progress =
          action?.payload?.progress;
        tempBulkFileListDetails[action.payload.index].uploading = true;
      }
      return {
        ...state,
        bulkFileList: tempBulkFileListDetails,
      };
    }

    case RESET_BULK_UPLOAD_FILE_LIST: {
      return {
        ...state,
        bulkFileList: [],
      };
    }

    case RESET_RESOURCE_FILE_DETAIL: {
      return {
        ...state,
        resourceFileDetails: undefined,
      };
    }
    case UPDATE_RESOURCE_FILE_SUCCESS: {
      const tempResourceFileDetails = cloneDeep(state.resourceFileDetails);
      const index = tempResourceFileDetails.data.findIndex(
        (obj) => obj._id === action.payload._id
      );
      if (index !== -1) {
        if (
          tempResourceFileDetails.data[index].parent_folder_id ===
          action.payload.parent_folder_id
        ) {
          tempResourceFileDetails.data[index] = action.payload;
        } else {
          remove(
            tempResourceFileDetails.data,
            (obj) => obj._id === action.payload._id
          );
        }
      }

      return {
        ...state,
        resourceFileDetails: tempResourceFileDetails,
      };
    }
    case SEARCH_RESOURCE_FILE_DETAILS_SUCCESS: {
      return {
        ...state,
        searchedFileDetails: action.payload,
      };
    }
    case GET_RESOURCE_QUESTIN_LIST_SUCCESS: {
      return {
        ...state,
        resourceQuestionList: action.payload,
      };
    }
    case SET_NEW_LOCAL_QUESTION: {
      return {
        ...state,
        newQuestion: action.payload,
      };
    }
    case UPDATE_NEW_LOCAL_QUESTION: {
      const tempResourceQuestionDetails = cloneDeep(state.newQuestion);
      tempResourceQuestionDetails[action.payload.key] = action.payload.value;
      return {
        ...state,
        newQuestion: tempResourceQuestionDetails,
      };
    }
    case UPDATE_NEW_LOCAL_QUESTION_OPTIONS: {
      const tempResourceQuestionDetails = cloneDeep(state.newQuestion);
      tempResourceQuestionDetails.options[action.payload.index][
        action.payload.key
      ] = action.payload.value;

      if (
        tempResourceQuestionDetails.question_type ===
        QuestionType.MULTIPLE_CHOICE &&
        action.payload.key === "correct_answer" &&
        action.payload.value === true
      ) {
        for (let i = 0; i < tempResourceQuestionDetails.options.length; i++) {
          if (i !== action.payload.index) {
            tempResourceQuestionDetails.options[i][action.payload.key] = false;
          }
        }
      }
      return {
        ...state,
        newQuestion: tempResourceQuestionDetails,
      };
    }

    case CREATE_RESOURCE_QUESTION_SUCCESS: {
      const tempResourceQuestionList = cloneDeep(state.resourceQuestionList);
      tempResourceQuestionList.push(action.payload);
      return {
        ...state,
        resourceQuestionList: tempResourceQuestionList,
        newQuestion: null,
      };
    }

    case DELETE_RESOURCE_QUESTION_SUCCESS: {
      const tempResourceQuestionList = cloneDeep(state.resourceQuestionList);
      const newItems = [];
      for (let i = 0; i < tempResourceQuestionList.length; i++) {
        if (!action.payload.includes(tempResourceQuestionList[i]._id)) {
          newItems.push(tempResourceQuestionList[i]);
        }
      }
      return {
        ...state,
        resourceQuestionList: newItems,
      };
    }

   case ADD_NEW_QUESTION_OPTIONS: {
  return {
    ...state,
    newQuestion: {
      ...state.newQuestion,
      options: [
        ...state.newQuestion.options, 
        {
          ...action.payload,
          order: action.payload.order || state.newQuestion.options.length
        }
      ]
    }
  };
}

    case UPDATE_RESOURCE_QUESTION_SUCCESS: {
      const tempQuestionList = state.resourceQuestionList.map(item =>
        item._id === action.payload._id ? { ...action.payload } : item
      );

      return {
        ...state,
        resourceQuestionList: tempQuestionList,
      };
    }
    

    case RESET_NEW_CURRENT_QUESTIONS: {
      return {
        ...state,
        newQuestion: undefined,
      };
    }
    case RESET_RESOURCES: {
      return {
        ...state,
        resourceDetails: undefined,
      }
    }
    default:
      return state;
  }
};
